import { DataDogTransport } from '@loglayer/transport-datadog';
import { serializeError } from 'serialize-error';
import { LogLayer } from 'loglayer';

import { BASE_URL, IS_DEV } from '@lib/constants/env';
import { isClient } from '@lib/utils';

function initLogger() {
  const API_KEY = process.env.DATA_DOG_API_KEY;

  if (!API_KEY) throw new Error('DATA_DOG_API_KEY is missing!');

  const serverLogger = new LogLayer({
    errorSerializer: serializeError,
    transport: [
      new DataDogTransport({
        options: {
          service: 'server-portal',
          ddtags: `env:${process.env.ENV},host:${BASE_URL}`,
          ddClientConf: {
            authMethods: {
              apiKeyAuth: API_KEY,
            },
          },
          ddServerConf: {
            site: 'us5.datadoghq.com',
          },
          onDebug: (msg) => {
            console.log(msg);
          },
          onError: (err, logs) => {
            console.error(err, logs);
          },
        },
      }),
    ],
  });

  return serverLogger;
}

export function sLog(): LogLayer | Console {
  if (isClient()) return console;
  if (IS_DEV) return console;

  if (!globalThis.__sLogger) {
    globalThis.__sLogger = initLogger();
  }

  return globalThis.__sLogger;
}
